import { apiHelper } from "@/utils";
import { API } from "@/constants";
import { orderTotals } from "@/utils/order.helper";

const API_URL = `${API.BASE_URL_API}/v1`;
export const orderService = { getAll, store, show, update, softDelete };
export function getAll(filter = {}) {
  const params = {
    page: filter.pageNumber,
    size: filter.pageSize,
    status_uuid: filter.statusUUID || undefined,
    date_from: filter.dateFrom || undefined,
    date_to: filter.dateTo || undefined,
  };
  if (filter.searchArray?.length) params.search_words = filter.searchArray;
  return apiHelper(API_URL).get("/orders", { params });
}
function payload(data) {
  return { buyer_uuid: data.buyerUUID, ...orderTotals(data.items) };
}
export function store(data) {
  return apiHelper(API_URL).post("/orders", payload(data));
}
export function show(uuid) {
  return apiHelper(API_URL).get(`/orders/${uuid}`);
}
export function update(data) {
  return apiHelper(API_URL).put(`/orders/${data.uuid}`, payload(data));
}
export function softDelete(uuid) {
  return apiHelper(API_URL).patch(`/orders/delete/${uuid}`);
}
